module.exports = __webpack_public_path__ + "static/media/marron.36a0969a.png";